import { trackUser } from '@api/tracking/client';
import type { TrackingContext } from '@mentimeter/http-clients';
import { useOnce } from '@mentimeter/react-hooks';
import type { PaywallType, UpgradeType } from '../../types';

export interface OpenPaywallTrackingProperties {
  trackingContext: TrackingContext | undefined;
  trackingPlacement: string;
  upgradeType: UpgradeType;
  paywallType?: PaywallType;
}

export function trackOpenPaywall({
  trackingContext,
  trackingPlacement,
  upgradeType,
  paywallType = 'Classic',
}: OpenPaywallTrackingProperties) {
  trackUser({
    event: 'Opened paywall',
    properties: {
      context: trackingContext,
      placement: trackingPlacement,
      'upgrade type': upgradeType,
      'paywall type': paywallType,
    },
  });
}

export function useTrackOpenPaywall({
  trackingContext,
  trackingPlacement,
  upgradeType,
}: OpenPaywallTrackingProperties) {
  useOnce(true, () => {
    trackOpenPaywall({ trackingContext, trackingPlacement, upgradeType });
  });
}
